module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/1b1N7fx298mD7Q3zZV7jPo-48c7ebac3c2436b019eed8e884f3180d.jpg";